var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "modal",
        resizable: true,
        adaptive: true,
        width: "700px",
        height: "550px"
      }
    },
    [
      _c("div", { staticStyle: { float: "right" } }, [
        _c("button", { on: { click: _vm.close } }, [
          _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])
        ])
      ]),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "carousel",
            {
              attrs: {
                center: "center",
                autoplay: true,
                responsive: {
                  0: { items: 1, nav: false },
                  600: { items: 1, nav: false }
                },
                nav: false
              }
            },
            _vm._l(_vm.notificaciones, function(notificacion) {
              return _c(
                "div",
                {
                  key: notificacion.id,
                  staticClass: "item",
                  staticStyle: { "text-align": "center", height: "460px" }
                },
                [
                  _c("h3", [_vm._v(_vm._s(notificacion.descripcion))]),
                  _vm._v(" "),
                  notificacion.url_image != null
                    ? _c("img", {
                        staticClass: "img-fluid",
                        staticStyle: {
                          width: "100%",
                          height: "380px",
                          "text-align": "center",
                          "margin-top": "10px",
                          padding: "4px"
                        },
                        attrs: {
                          src: _vm.urlPage + "/" + notificacion.url_image
                        }
                      })
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticStyle: {
          bottom: "0",
          position: "absolute",
          "text-align": "center",
          left: "0%",
          right: "0%"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5770cbed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5770cbed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/notyModal.vue
// module id = 220
// module chunks = 0